import { createQueryKeys } from '@lukemorales/query-key-factory';

export const team = createQueryKeys('team', {
  detail: null,
});
